import { FormlyFieldConfig } from '@ngx-formly/core';

export function uenValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `UEN is invalid`;
}
